import Eca from "@/features/gis/Eca.jsx"
import HighRisk from "@/features/gis/HighRisk.jsx"
import Jwla from "@/features/gis/Jwla.jsx"
import OperationalRisk from "@/features/gis/OperationalRisk.jsx"
import Ports from "@/features/gis/Ports.jsx"
import Regions from "@/features/gis/Regions.jsx"
import Restrictions from "@/features/gis/Restrictions.jsx"
import ViaAreas from "@/features/gis/ViaAreas.jsx"
import PilotStations from "@/features/gis/PilotStations.jsx"

// Bündelt die statischen GIS-Layer; die GeoJSON-States bleiben in
// MainComponent, weil auch der VoyagePlanner sie liest.
export default function GisLayers({
  toggleFlags,
  switchGisLayersActive,
  zoomLevel,
  dragged,
  resized,
  setVoyageActive,
  cwPortGeojson,
  setCwPortGeojson,
  voyagePlannerPoints,
  setVoyagePlannerPoints,
  cwRegionGeojson,
  setCwRegionGeojson,
  cwRestrictionGeojson,
  setCwRestrictionGeojson,
  cwViaAreasGeojson,
  setCwViaAreasGeojson,
  cwPilotStationGeojson,
  setCwPilotStationGeojson,
}) {
  return (
    <>
      <Eca
        toggleFlags={toggleFlags}
        switchGisLayersActive={switchGisLayersActive}
      />
      <HighRisk
        toggleFlags={toggleFlags}
        switchGisLayersActive={switchGisLayersActive}
      />
      <Jwla
        toggleFlags={toggleFlags}
        switchGisLayersActive={switchGisLayersActive}
      />
      <OperationalRisk
        toggleFlags={toggleFlags}
        switchGisLayersActive={switchGisLayersActive}
      />
      <Ports
        cwPortGeojson={cwPortGeojson}
        setCwPortGeojson={setCwPortGeojson}
        voyagePlannerPoints={voyagePlannerPoints}
        setVoyagePlannerPoints={setVoyagePlannerPoints}
        toggleFlags={toggleFlags}
        zoomLevel={zoomLevel}
        dragged={dragged}
        resized={resized}
        switchGisLayersActive={switchGisLayersActive}
      />
      <Regions
        cwRegionGeojson={cwRegionGeojson}
        setCwRegionGeojson={setCwRegionGeojson}
        toggleFlags={toggleFlags}
        zoomLevel={zoomLevel}
        dragged={dragged}
        resized={resized}
        switchGisLayersActive={switchGisLayersActive}
      />
      <Restrictions
        cwRestrictionsGeojson={cwRestrictionGeojson}
        setCwRestrictionsGeojson={setCwRestrictionGeojson}
        toggleFlags={toggleFlags}
        zoomLevel={zoomLevel}
        dragged={dragged}
        resized={resized}
        setVoyageActive={setVoyageActive}
        switchGisLayersActive={switchGisLayersActive}
      />
      <ViaAreas
        cwViaAreasGeojson={cwViaAreasGeojson}
        setCwViaAreasGeojson={setCwViaAreasGeojson}
        toggleFlags={toggleFlags}
        zoomLevel={zoomLevel}
        dragged={dragged}
        resized={resized}
        setVoyageActive={setVoyageActive}
        switchGisLayersActive={switchGisLayersActive}
      />
      <PilotStations
        cwPilotStationGeojson={cwPilotStationGeojson}
        setCwPilotStationGeojson={setCwPilotStationGeojson}
        toggleFlags={toggleFlags}
        zoomLevel={zoomLevel}
        dragged={dragged}
        resized={resized}
        switchGisLayersActive={switchGisLayersActive}
      />
    </>
  )
}
